import React from 'react'
import { Field, WrappedFieldProps } from 'redux-form'
import { IFormElementProps } from './FormElement/FormInput'

type InputComponent<P> =
  | React.ComponentType<P>
  | 'input'
  | 'select'
  | 'textarea'

function withReduxForm<T extends IFormElementProps>(
  Component: InputComponent<WrappedFieldProps>,
) {
  return function(props: T) {
    function normalize(val, pVal, all) {
      const value =
        typeof val === 'string'
          ? val.replace(
          /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          '',
          )
          : val
      if (props.normalize) {
        return props.normalize(value, pVal, all)
      }
      return value
    }

    return <Field {...props} normalize={normalize} component={Component}/>
  }
}

export default withReduxForm
